import { Box, Collapse, TableCell, TableRow, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChargeFormEntry } from '../../../../types';
import { InvolvedPartyTable } from './components/InvolvedPartyTable';

const useStyles = makeStyles((theme) => ({
  tableCell: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  text: {
    fontSize: '0.8rem',
  },
  amount: {
    fontSize: '0.8rem',
    fontWeight: 500,
    color: 'black',
  },
  atClosing: {
    fontSize: '0.8rem',
    justifySelf: 'flex-end',
    paddingRight: '5px',
  },
  title: {
    padding: '10px 10px 0px',
    fontSize: '0.8rem',
    fontWeight: 500,
    color: 'black',
  },
  partyContainer: {
    padding: '5px 10px',
    borderBottom: '1px solid lightgray',
  },
}));

type Props = {
  open: boolean;
  charge: ChargeFormEntry;
  onEditParties: (charge: ChargeFormEntry, kind: 'Payee' | 'Payer' | 'Tax') => void;
};

export const PartiesInvolvedRow: FC<Props> = ({ open, charge, onEditParties }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell className={classes.tableCell} />
      <TableCell className={classes.tableCell} />
      <TableCell className={classes.tableCell} />
      <TableCell style={{ padding: 0 }} colSpan={9}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box style={{ display: 'flex', gap: '10px', padding: '10px 5px' }}>
            {charge.payees.length > 0 && charge.payees.some(({ amount }) => amount > 0) && (
              <InvolvedPartyTable
                parties={charge.payees}
                title={t('orders:payeesLabel')}
                onEditClick={() => onEditParties(charge, 'Payee')}
              />
            )}
            {charge.payers.length > 0 && charge.payers.some(({ amount }) => amount > 0) && (
              <InvolvedPartyTable
                parties={charge.payers}
                title={t('orders:payersLabel')}
                onEditClick={() => onEditParties(charge, 'Payer')}
              />
            )}
            {charge.taxes.length > 0 && charge.taxes.some(({ amount }) => amount > 0) && (
              <InvolvedPartyTable
                parties={charge.taxes}
                title={t('orders:taxesLabel')}
                onEditClick={() => onEditParties(charge, 'Tax')}
              />
            )}
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
